import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';

const Work = () => {
  const [projects, setProjects] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  const categories = ["ALL", "Brand", "Creation", "Event & Experience"];

  useEffect(() => {
    const readProjectsData = async () => {
      let projectsRef = query(
        collection(db, 'projects'),
        orderBy('createdAt', 'desc'),
        where('isVisible', '==', true)
      );

      if (selectedCategory !== "ALL") {
        projectsRef = query(
          collection(db, 'projects'),
          orderBy('createdAt', 'desc'),
          where('projectType', '==', selectedCategory),
          where('isVisible', '==', true)
        );
      }

      const unsubscribe = onSnapshot(projectsRef, (snapshot) => {
        setProjects(snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      return () => unsubscribe();
    };

    readProjectsData();
  }, [selectedCategory]);

  return (

    <>
      <Helmet>
        <title>{`WEAREBIAM | WORK`}</title>
        <meta
          name="description"
          content={'All Creatives Projects by WEAREBIAM'}
        />

        {/* Open Graph tags */}
        <meta property="og:title" content={`WEAREBIAM | WORK`} />
        <meta
          property="og:description"
          content={'All Creatives Projects by WEAREBIAM'}
        />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/assets%2Fwebcover_bw.png?alt=media&token=f3686ce5-b347-4f99-8b23-0f52d461675c" />
        <meta property="og:url" content={`https://wearebiam.com/work`} />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="flex items-center justify-center bg-black w-full">
        <div className='flex flex-col max-w-[1440px] gap-[30px] w-full min-h-screen bg-black lg:p-[5rem] p-[1.25rem]'>

          <motion.p
            className="text-white lg:text-[24px] text-[20px] font-bold ppmori lg:mt-[50px] mt-[100px]"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            When we start a project our goal is to <br className='lg:block hidden' />
            create something that stands out in a <br className='lg:block hidden' />
            sea of sameness.
          </motion.p>

          {/* Catégories (Filtres) */}
          <motion.div
            id='categories'
            className="flex gap-5 mt-5 lg:ml-10 ml-5 overflow-x-scroll ppmori uppercase w-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {categories.map((cat, idx) => (
              <motion.p
                key={idx}
                className={`lg:text-[12px] text-[16px] cursor-pointer transition-all duration-200 ${selectedCategory === cat ? 'text-white font-bold' : 'text-lightgrey3'}`}
                onClick={() => setSelectedCategory(cat)}
                whileHover={{ scale: 1.05 }}
              >
                {cat}
              </motion.p>
            ))}
          </motion.div>

          {/* Liste des Projets */}
          <motion.div
            className="grid lg:grid-cols-3 items-stretch gap-10 grid-cols-1 lg:mt-0"
            initial="hidden"
            animate="visible"
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.15
                }
              }
            }}
          >
            {projects.length > 0 ? (
              <AnimatePresence>
                {projects.map((project, idx) => (
                  <motion.div
                    key={project.id}
                    variants={{
                      hidden: { opacity: 0, scale: 0.95 },
                      visible: { opacity: 1, scale: 1 }
                    }}
                    exit={{ opacity: 0, scale: 0.9 }}
                    transition={{ duration: 0.5 }}
                  >
                    <Link to={`/work/project/${project.id}`} className="flex flex-col gap-1">
                      <div
                        className="flex w-full aspect-[4/5] bg-darkgrey bg-cover bg-no-repeat bg-center rounded-[10px]"
                        style={{ backgroundImage: `url(${project.data.coverUrl})` }}
                      />
                      <div className="flex items-center justify-between w-full px-[0.1rem] text-white">
                        <p className="flex flex-col">{project.data.projectName}</p>
                        <p className="flex gap-2.5 items-center justify-center">{project.data.year}</p>
                      </div>
                    </Link>
                  </motion.div>
                ))}
              </AnimatePresence>
            ) : (
              <motion.p
                className="text-white text-center w-full mt-10"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
              >
                Aucun projet trouvé pour cette catégorie.
              </motion.p>
            )}
          </motion.div>
        </div>
      </div>
    </>


  );
};

export default Work;
